
import React from 'react';
import { Star } from 'lucide-react';

interface TestimonialProps {
  quote: string;
  author: string;
  stars: number;
  type: string;
}

const Testimonial = ({ quote, author, stars, type }: TestimonialProps) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
      <div className="flex mb-3">
        {[...Array(5)].map((_, i) => (
          <Star 
            key={i} 
            className={`w-5 h-5 ${i < stars ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'} mr-1`} 
          />
        ))}
      </div>
      <p className="text-gray-700 italic mb-4">"{quote}"</p>
      <div>
        <p className="font-semibold">{author}</p>
        <p className="text-sm text-gray-500">{type}</p>
      </div>
    </div>
  );
};

const ExperiencedTestimonials = () => {
  const testimonials = [
    {
      quote: "Oscar har hjulpet mig med at tage mit klaverspil til et helt nyt niveau. Hans dybdegående forståelse af teknik og musikalsk udtryk har åbnet døre, jeg ikke vidste eksisterede i min egen fortolkning.",
      author: "Mikkel Andersen",
      stars: 5,
      type: "Konservatoriestuderende"
    },
    {
      quote: "Efter at have nået et plateau i mit klaverspil, har Oscars specialiserede undervisning givet mig præcis de værktøjer, jeg havde brug for til at komme videre. Hans evne til at identificere og løse tekniske problemer er exceptionel.",
      author: "Sofie Nielsen",
      stars: 5,
      type: "Øvet amatørpianist, 15 års erfaring"
    },
    {
      quote: "Jeg har prøvet mange klaverlærere gennem årene, men Oscar skiller sig ud ved sin evne til at tilpasse sin undervisning til mine specifikke behov og mål. Hans feedback er altid konstruktiv og inspirerende.",
      author: "Peter Møller",
      stars: 5,
      type: "Tidligere musikskolelærer"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-serif font-bold mb-4">
            Hvad mine øvede elever siger
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Hør fra andre pianister, der har taget deres spil til næste niveau gennem min specialiserede undervisning.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Testimonial 
              key={index}
              quote={testimonial.quote}
              author={testimonial.author}
              stars={testimonial.stars}
              type={testimonial.type}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperiencedTestimonials;
